import PropTypes from "prop-types";

const RadioInput = ({
  options,
  formik,
  saveError = null,
  fieldName,
  label,
  onChange = null,
}) => {
  return (
    <div className="flex flex-row justify-between">
      <label>{label}</label>
      <div className="flex flex-col">
        <div className="flex flex-row gap-3 w-[450px]">
          {options.map((option) => (
            <label
              key={option.value}
              htmlFor={`${fieldName}-${option.value}`}
              className="flex items-center gap-1 cursor-pointer py-2 rounded-md focus:ring-2 focus:ring-blue-500"
            >
              <input
                id={`${fieldName}-${option.value}`}
                type="radio"
                value={option.value}
                checked={formik.values[fieldName] === option.value}
                onChange={() => {
                  onChange
                    ? onChange(option)
                    : formik.setFieldValue(fieldName, option.value);
                }}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </div>
        {((formik.touched[fieldName] && formik.errors[fieldName]) ||
          saveError?.status === 422) && (
          <div className="text-destructive w-[450px]">
            {formik?.errors[fieldName] ??
              saveError?.response?.data?.errors[fieldName]?.join(" ")}
          </div>
        )}
      </div>
    </div>
  );
};

RadioInput.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
      ]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  formik: PropTypes.shape({
    values: PropTypes.object.isRequired,
    touched: PropTypes.object,
    errors: PropTypes.object,
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
  saveError: PropTypes.shape({
    status: PropTypes.number,
    response: PropTypes.shape({
      data: PropTypes.shape({
        errors: PropTypes.object,
      }),
    }),
  }),
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

export default RadioInput;
